export class InvalidTelemetryUnitPinError extends Error {
    constructor(message: string = 'Invalid telemetry unit Pin') {
        super(message);
        this.name = 'InvalidTelemetryUnitPinError';
        Object.setPrototypeOf(this, InvalidTelemetryUnitPinError.prototype);
    }
}
